import MatchDetailOddModel from './model-match-details-odd';
import MatchDetailsOutcomeModel from './model-match-details-outcome';
import OutrightModel from '../../category-outrights/model-outright';
import OutrightOutcomeModel from '../../category-outrights/model-outright-outcome';

/**
 * Model for match markets
 */
export default class MatchDetailsTabModel {
  /**
   * class constructor method
   * @param data
   * @param {number} sportId sport id from parent model
   */
  constructor(data, sportId = 0, homeTeam = "", guestTeam = "") {
    /**
     * Tab id
     * @type {number}
     */
    this.id = data.id;
    /**
     * Market name
     * @type {string}
     */
    this.name = data.n;
    /**
     * Market description
     * @type {string}
     */
    this.description = data.d;
    /**
     * odds
     * @type {array}
     */
    if (data.is) {
      this.odds = this.processScorecastOdds(data.o);
    } else {
      this.odds = this.mapOdds(data.o, homeTeam, guestTeam);
    }
    /**
     * A flag indicating if tab is scorecast
     */
    this.isScorecast = data.is;
    /**
     * List of all outrights for outrights tab if present defaults to []
     */
    const outrights = data.ou ? this.mapOutrights(data.ou, sportId) : [];
    /**
     * Filtered list of outrights that have multiple outcomes
     */
    this.multiOutrights = outrights.filter((o) => o.outcomes.length > 1);
    /**
     * Filtered list of outrights that have single outcome
     */
    this.directOutrights = outrights.filter((o) => o.outcomes.length === 1);
  }

  /**
   * Method that re-maps scorecast odds into a hirearchy of markets (odds) -> players -> outcomes
   * @param {Array} oddsList
   */
  processScorecastOdds(oddsList) {
    if (!oddsList) {
      return [];
    }

    let odds = [];

    oddsList.forEach((scoreType) => {
      let playersArray = [];
      scoreType.p.forEach((player) => {
        let playerObject = {};
        playerObject.name = player.sbv;
        playerObject.outcomes = player.o.map((outcome) => new MatchDetailsOutcomeModel(outcome));
        playersArray.push(playerObject);
      });

      odds.push({
        id: scoreType.id,
        marketName: scoreType.n,
        players: playersArray,
      });
    });

    return odds;
  }

  mapOdds(oddsList, homeTeam, guestTeam) {
    if (!oddsList) {
      return [];
    }
    let odds = [];
    oddsList.forEach((o) => {
      let odd = new MatchDetailOddModel(o, homeTeam, guestTeam, this.id);
      odd.outcomes = o.m.map((m) => new MatchDetailsOutcomeModel(m, homeTeam, guestTeam));
      odds.push(odd);
    });
    return odds;
  }

  /**
   * Method for mapping inner objects from API with parent model
   * @param outrightList list of match outrights
   * @param {number} sportId sportId from parent model
   * @return {OutrightModel[]} mapped outrights in proper outright model
   */
  mapOutrights(outrightList, sportId) {
    let outrights = [];
    outrightList.forEach((o) => {
      let outright = new OutrightModel(o);
      outright.sportId = sportId;
      outright.outcomes = o.o.map((ort) => new OutrightOutcomeModel(ort));
      outrights.push(outright);
    });
    return outrights;
  }
}
